import { FC } from 'react';
import {
  MasterLayout,
  NavItem,
  OrgSwitcherPortal,
  ProfileInfoPortal,
} from '@mono/layout';
import { Outlet, useNavigate, useParams, Navigate } from 'react-router';
import { LuGrip } from 'react-icons/lu';
import { LuCog } from 'react-icons/lu';
import { LoginPage } from './features/auth/LoginPage';
import useSession from './features/session/useSession';
import { OnboardUserPage } from './features/organizations/OnboardUserPage';
import ProfileInfo from './features/profile/ProfileInfo';
import OrgSwitcher from './features/organizations/OrgSwitcher';

const navItems: NavItem[] = [
  {
    label: 'Home',
    path: 'home',
    icon: <LuGrip />,
  },
  {
    label: 'Settings',
    path: 'settings',
    icon: <LuCog />,
  },
];

const App: FC = () => {
  const navigate = useNavigate();
  const session = useSession();
  const params = useParams<{ orgSlug: string }>();

  if (!session.data && session.status === 'loading') {
    return 'Loading...';
  }

  if (session.status === 'unauthenticated') {
    return <LoginPage />;
  }

  if (session.data?.organizations.length === 0) {
    return <OnboardUserPage />;
  }

  if (!params.orgSlug) {
    return <Navigate to={`/${session.data?.organizations[0].slug}/`} />;
  }

  return (
    <MasterLayout
      navItems={navItems}
      onClickNavItem={(path) => navigate(`/${params.orgSlug}/${path}`)}
    >
      <OrgSwitcherPortal>
        <OrgSwitcher />
      </OrgSwitcherPortal>
      <ProfileInfoPortal>
        <ProfileInfo />
      </ProfileInfoPortal>
      <Outlet />
    </MasterLayout>
  );
};

export default App;
